
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, int32_type, record_type, bool_type, class_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class Event$ extends Record {
    constructor(id, title, start, end, allDay) {
        super();
        this.id = id;
        this.title = title;
        this.start = start;
        this.end = end;
        this.allDay = allDay;
    }
}

export function Event$_$reflection() {
    return record_type("Feliz.ReactBigCalendar.Event", [], Event$, () => [["id", string_type], ["title", string_type], ["start", class_type("System.DateTime")], ["end", class_type("System.DateTime")], ["allDay", bool_type]]);
}

export class Messages extends Record {
    constructor(allDay, previous, next, today, month, week, day, agenda, date, time, event, noEventsInRange, showMore) {
        super();
        this.allDay = allDay;
        this.previous = previous;
        this.next = next;
        this.today = today;
        this.month = month;
        this.week = week;
        this.day = day;
        this.agenda = agenda;
        this.date = date;
        this.time = time;
        this.event = event;
        this.noEventsInRange = noEventsInRange;
        this.showMore = showMore;
    }
}

export function Messages_$reflection() {
    return record_type("Feliz.ReactBigCalendar.Messages", [], Messages, () => [["allDay", string_type], ["previous", string_type], ["next", string_type], ["today", string_type], ["month", string_type], ["week", string_type], ["day", string_type], ["agenda", string_type], ["date", string_type], ["time", string_type], ["event", string_type], ["noEventsInRange", string_type], ["showMore", lambda_type(int32_type, string_type)]]);
}

